import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Importa useNavigate
import "./login.css"; // Importar el CSS personalitzat
import { setAuthToken } from "../utils/auth";
import { useUserContext } from "../utils/UserContext"; // Importa el context
import { API_URL } from "../utils/config";
import { rutaIniciSessio } from "../utils/Permisos";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate(); // Inicialitza navigate
  const { setRolUsuari, setEmpresaSeleccionada, setUsuariActiu, setEsSuperUsuari, setNomUsuari } = useUserContext(); // Accedeix al context

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/login.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const result = await response.json();
      if (result.success) {
        console.log("Rol retornat pel backend:", result.rol); // Mostra el rol al console
        console.log("Empresa retornada pel backend:", result.empresa); // Mostra l'empresa al console
        console.log("Id d'usuari retornat pel backend:", result.idUsuari); // Mostra l'id de l'usuari al console
        console.log("És superusuari:", result.esSuperUsuari); // Mostra si és superusuari al console
        console.log("Nom d'usuari retornat pel backend:", result.nomUsuari); // Mostra el nom d'usuari al console
        setAuthToken(result.token); // Desa el token retornat pel servidor
        setRolUsuari(result.rol); // Desa el rol al context
        setEmpresaSeleccionada(result.empresa); // Desa l'empresa al context
        setUsuariActiu(result.idUsuari); // Desa el id de d'usuari al context
        setEsSuperUsuari(result.esSuperUsuari); // Desa si és superusuari al context
        setNomUsuari(result.nomUsuari); // Desa el nom d'usuari al context

        navigate(
          rutaIniciSessio({
            rol: result.rol,
            esSuperUsuari: result.esSuperUsuari,
            empresa: result.empresa,
          })
        ); 
      } else {
        alert(result.message); // Mostra l'error
      }
    } catch (error) {
      console.error("Error en la crida al servidor:", error);
      alert("Error al processar la sol·licitud. Torna a intentar-ho.");
    }
  };

  return (
    <div className="login-container">
      <div className="card p-4">
        <h2 className="text-center mb-4">Inicia sessió</h2>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">
              Nom d'usuari
            </label>
            <input
              type="text"
              className="form-control"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Contrasenya
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Iniciar sessió
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
